type Breadcrumb = {
  to: string,
  label: string
}

export const questionsBreadcrumbs: Breadcrumb[] = [
    {
      to: "/",
      label: "Home",
    },
    {
      to: "/common-questions",
      label: "Common Questions",
    },
  ];

export const contactBreadcrumbs: Breadcrumb[] = [
    {
      to: "/",
      label: "Home",
    },
    {
      to: "/contact",
      label: "Contact",
    },
  ];